export default {
  secondStepTitle: {
    id: 'cookies_modal_title',
    defaultMessage: 'Configure',
  },
  paragraph: {
    id: 'cookies_modal_content',
    defaultMessage:
      'We and our partners also use cookies that allow us to measure traffic and show you personalized content and ads rather than basic shiz. Think sea salt chocolate chunk vs. oatmeal raisin.',
  },
  usage: {
    id: 'cookies_modal_usage',
    defaultMessage:
      'You can change your preferences later by clicking “Cookies” at the bottom of any page. {link, html}',
  },
  knowMore: {
    id: 'cookies_modal_know_more',
    defaultMessage: 'Tell me more about these cookies',
  },
  buttonSettings: {
    id: 'cookies_modal_settings',
    defaultMessage: 'Change settings',
  },
  buttonAccept: {
    id: 'cookies_modal_accept',
    defaultMessage: "I'm cool with that",
  },
  buttonRefuse: {
    id: 'cookies_modal_refuse',
    defaultMessage: 'I refuse your cookies',
  },
  save: {
    id: 'cookies_modal_save',
    defaultMessage: 'Save',
  },
}
